import React from "react";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { AppHeader } from "@/ui";
import { MUTATION_UI } from "../../../apollo/mutations/local";
import { QUERY_UI } from "../../../apollo/queries/local";
import HeaderOptions from "./HeaderOptions";
import DeploymentStatus from "./deployment-status/DeploymentStatus";
import StoreSelector from "./stores/StoreSelector";
import UserMenu from "./user-menu/UserMenu";

const Header = () => {
    const { data } = useQuery(QUERY_UI);
    const [updateUi] = useMutation(MUTATION_UI);
    const ui = data?.ui;
    const asideMinimize = ui?.asideMinimize ?? true;

    const handleToggleNavigation = () => {
        updateUi({
            variables: {
                ui: {
                    asideHover: false,
                    asideMinimize: !asideMinimize,
                    asideToggle: false,
                    headerToggle: ui?.headerToggle ?? false,
                },
            },
        });
    };

    return (
        <AppHeader layout="chrome">
            <AppHeader.BrandSlot>
                <AppHeader.NavToggle
                    aria-label="Toggle navigation menu"
                    onClick={handleToggleNavigation}
                    pressed={asideMinimize}
                />
                <AppHeader.Brand />
            </AppHeader.BrandSlot>
            <AppHeader.ProfileSlot>
                <HeaderOptions />
                <UserMenu />
            </AppHeader.ProfileSlot>
            <AppHeader.StoreToolbar>
                <StoreSelector />
                <AppHeader.Divider />
                <DeploymentStatus />
            </AppHeader.StoreToolbar>
        </AppHeader>
    );
};

export default Header;
